var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"helpId"}},[_c('iframe',{attrs:{"id":"myframe","width":"100%","height":"100%","src":_vm.url}})])}
var staticRenderFns = []

export { render, staticRenderFns }